import { required, number, numeric, string, isnil } from 'vue-mc/validation'
import BaseModel from '@/models/BaseModel'

export default class Combo extends BaseModel {
  defaults () {
    return {
      name: null,
      internalId: null,
      cost: 0,
      price: 0,
      restaurant: null,
      status: 'in-progress',
      weeklySale: 0,
      section: null
    }
  }

  options () {
    return {
      methods: {

      }
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'DELETE',
      updateStatus: 'PUT',
      getDishes: 'GET',
      addDishes: 'POST',
      updateDishes: 'PUT',
      removeDishes: 'DELETE'
    }
  }

  validation () {
    return {
      name: [required.and(string)],
      externalId: [
        this.id
          ? required.and(string)
          : isnil.or('string')
      ],
      cost: [number.or(numeric)],
      price: [number.or(numeric)],
      restaurant: [required.and(string)],
      status: [required.and(string)],
      weeklySale: [number.or(numeric)]
    }
  }

  shouldPatch () {
    return true
  }

  updateStatus (data) {
    let method = this.getOption('methods.updateStatus')
    let route = this.getRoute('updateStatus')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  detail () {
    let method = this.getOption('methods.detail')
    let route = this.getRoute('detail')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  getDishes () {
    let method = this.getOption('methods.getDishes')
    let route = this.getRoute('getDishes')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  addDishes (data) {
    let method = this.getOption('methods.addDishes')
    let route = this.getRoute('addDishes')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  updateDishes (data) {
    let method = this.getOption('methods.updateDishes')
    let route = this.getRoute('updateDishes')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  removeDishes () {
    let method = this.getOption('methods.removeDishes')
    let route = this.getRoute('removeDishes')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/combos`,
      save: `${this.API_BASE}/v1/combos`,
      delete: `${this.API_BASE}/v1/combos/{id}`,
      patch: `${this.API_BASE}/v1/combos/{id}`,
      detail: `${this.API_BASE}/v1/combos/{id}`,
      updateStatus: `${this.API_BASE}/v1/combos/{id}/status`,
      getDishes: `${this.API_BASE}/v1/combos/{id}/dishes`,
      addDishes: `${this.API_BASE}/v1/combos/{id}/dishes`,
      updateDishes: `${this.API_BASE}/v1/combos/{id}/dishes/{recipe}`,
      removeDishes: `${this.API_BASE}/v1/combos/{id}/dishes/{recipe}`
    }
  }
}
